export default "__VITE_ASSET__BobJ66_o__"